var Map = function(key) {
  var $ = require('jquery');
  var $map = $('[data-map="true"]');

  if (!$map.hasClass('property-map')) {
    var GoogleMapsLoader = require('google-maps');
    GoogleMapsLoader.KEY = key;
    GoogleMapsLoader.load(function(google) {
      var cords = new google.maps.LatLng(parseFloat($map.attr('data-lat')), parseFloat($map.attr('data-lng')));
      var map = new google.maps.Map($map[0], {
        center: cords,
        zoom: 12,
        scrollwheel: false
      });
      var gmark = new google.maps.Marker({
        position: cords,
        map: map,
      });
    });
  }

}
module.exports = Map;